module.exports = __webpack_public_path__ + "img/petuhov.1fab56f1.jpg";